export default function () {
    const $ = window.jQuery;

    const form = $('#activecampaign-for-woocommerce-options-form');

    let url = form.attr("action");
    let type = form.attr("method");
    let data = form.serialize();

    return new Promise((resolve, reject) => {
        $.ajax({
            url,
            type,
            data
        }).done(response => {
            resolve(response.data);
        }).fail(response => {
            reject(response.responseJSON.data)
        });
    })
}



// WEBPACK FOOTER //
// ./admin/src/js/scripts/ajaxSettingsForm.js